var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"face-wrap"},[_c('img',{staticClass:"face",attrs:{"src":_vm.face}}),_vm._v(" "),(_vm.grade == 1)?_c('img',{staticClass:"ico-v",attrs:{"src":_vm.icon}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }